// Generated by CoffeeScript 2.4.1
(function() {
  var Weaver, WeaverQueryBuilder, _, luxon, moment, supportedMethods,
    splice = [].splice;

  Weaver = require('./Weaver');

  moment = require('moment');

  luxon = require('luxon');

  _ = require('lodash');

  supportedMethods = {
    alwaysLoadAttributes: function(q, ...attributeKeys) {
      return q.alwaysLoadAttributes(...attributeKeys);
    },
    alwaysLoadRelations: function(q, ...relationKeys) {
      return q.alwaysLoadRelations(...relationKeys);
    },
    ascending: function(q, keys) {
      return q.ascending(keys);
    },
    batchSize: function(q, batchSize) {
      return q.batchSize(batchSize);
    },
    containedIn: function(q, key, values) {
      return q.containedIn(key, values);
    },
    contains: function(q, key, value) {
      return q.contains(key, value);
    },
    containsAll: function(q, key, values) {
      return q.containsAll(key, values);
    },
    createdBy: function(q, user) {
      return q.createdBy(user);
    },
    descending: function(q, keys) {
      return q.descending(keys);
    },
    doesNotExist: function(q, key) {
      return q.doesNotExist(key);
    },
    endsWith: function(q, key, value) {
      return q.endsWith(key, value);
    },
    equalTo: function(q, key, value) {
      return q.equalToNew(key, value);
    },
    equalToIgnoreCase: function(q, key, value) {
      return q.equalToIgnoreCase(key, value);
    },
    exists: function(q, key) {
      return q.exists(key);
    },
    graphFilter: function(q, graphs) {
      return q.graphFilter(graphs);
    },
    greaterThan: function(q, key, value) {
      return q.greaterThan(key, value);
    },
    greaterThanOrEqualTo: function(q, key, value) {
      return q.greaterThanOrEqualTo(key, value);
    },
    hasLabel: function(q, ...labels) {
      return q.hasLabel(...labels);
    },
    hasNoLabel: function(q, ...labels) {
      return q.hasNoLabel(...labels);
    },
    hasNoRecursiveRelationIn: function(q, key, node, includeSelf = false) {
      return q.hasNoRecursiveRelationIn(key, node, includeSelf);
    },
    hasNoRecursiveRelationOut: function(q, key, node, includeSelf = false) {
      return q.hasNoRecursiveRelationOut(key, node, includeSelf);
    },
    hasNoRelationIn: function(q, key, ...node) {
      return q.hasNoRelationIn(key, ...node);
    },
    hasNoRelationOut: function(q, key, ...node) {
      return q.hasNoRelationOut(key, ...node);
    },
    hasRecursiveRelationIn: function(q, key, node, includeSelf = false) {
      return q.hasRecursiveRelationIn(key, node, includeSelf);
    },
    hasRecursiveRelationOut: function(q, key, node, includeSelf = false) {
      return q.hasRecursiveRelationOut(key, node, includeSelf);
    },
    hasRelationIn: function(q, key, ...node) {
      return q.hasRelationIn(key, ...node);
    },
    hasRelationOut: function(q, key, ...node) {
      return q.hasRelationOut(key, ...node);
    },
    hollow: function(q, value) {
      return q.hollow(value);
    },
    ignoreRelations: function(q, ...keys) {
      return q.ignoreRelations(...keys);
    },
    include: function(q, keys) {
      return q.include(keys);
    },
    inGraph: function(q, ...graphs) {
      return q.inGraph(...graphs);
    },
    lessThan: function(q, key, value) {
      return q.lessThan(key, value);
    },
    lessThanOrEqualTo: function(q, key, value) {
      return q.lessThanOrEqualTo(key, value);
    },
    limit: function(q, limit) {
      return q.limit(limit);
    },
    limitRelations: function(q, limit) {
      return q.limitRelations(limit);
    },
    matches: function(q, key, value) {
      return q.matches(key, value);
    },
    noAttributes: function(q) {
      return q.noAttributes();
    },
    noRelations: function(q) {
      return q.noRelations();
    },
    notContainedIn: function(q, key, values) {
      return q.notContainedIn(key, values);
    },
    notEqualTo: function(q, key, value) {
      return q.notEqualTo(key, value);
    },
    notInGraph: function(q, ...graphs) {
      return q.notInGraph(...graphs);
    },
    or: function(q, queries) {
      return q.or(queries);
    },
    order: function(q, keys, ascending) {
      return q.order(keys, ascending);
    },
    restrict: function(q, ...nodes) {
      return q.restrict(nodes);
    },
    restrictGraphs: function(q, ...graphs) {
      return q.restrictGraphs(graphs);
    },
    select: function(q, ...keys) {
      return q.select(...keys);
    },
    selectIn: function(q, ...relationKeys) {
      return q.selectIn(...relationKeys);
    },
    selectInMinus: function(q, ...relationKeys) {
      return q.selectInMinus(...relationKeys);
    },
    selectInOnLoad: function(q) {
      return q.selectInOnLoad();
    },
    selectOut: function(q, ...relationKeys) {
      return q.selectOut(...relationKeys);
    },
    selectOutMinus: function(q, ...relationKeys) {
      return q.selectOutMinus(...relationKeys);
    },
    selectRecursiveIn: function(q, ...relationKeys) {
      return q.selectRecursiveIn(...relationKeys);
    },
    selectRecursiveOut: function(q, ...relationKeys) {
      return q.selectRecursiveOut(...relationKeys);
    },
    selectRelations: function(q, ...keys) {
      return q.selectRelations(...keys);
    },
    setLoggingTag: function(q, tag) {
      return q.setLoggingTag(tag);
    },
    skip: function(q, skip) {
      return q.skip(skip);
    },
    startsWith: function(q, key, value) {
      return q.startsWith(key, value);
    },
    withAttributes: function(q) {
      return q.withAttributes();
    },
    withRelations: function(q) {
      return q.withRelations();
    },
    isLike: function(q, key, value) {
      return q.isLike(key, value);
    },
    excludeNodesWith: function(q, key, value) {
      return q.excludeNodesWith(key, value);
    },
    excludeAttributesWith: function(q, key, value) {
      return q.excludeAttributesWith(key, value);
    },
    excludeRelationsWith: function(q, key, value) {
      return q.excludeRelationsWith(key, value);
    }
  };

  WeaverQueryBuilder = class WeaverQueryBuilder {
    constructor(payload, valueCallback) {
      this.payload = payload;
      this._parameters = {};
      this._valueCallback = valueCallback || (function(value) {
        return value;
      });
    }

    static substituteParameters(payload, parameters) {
      var i, item, key, len, occurrences, substitute;
      occurrences = WeaverQueryBuilder.findParameters(payload);
      for (i = 0, len = occurrences.length; i < len; i++) {
        item = occurrences[i];
        if (parameters[item] == null) {
          throw new Error(`No value set for the parameter ${item}`);
        }
      }
      for (key in parameters) {
        substitute = parameters[key];
        payload = payload.replace(new RegExp(`%\{${key}\}`, 'g'), substitute);
      }
      return payload;
    }

    static findParameters(string) {
      var entry, iterator, occurrences;
      occurrences = [];
      // The matchAll returns an Iterator
      iterator = string.matchAll(/\%\{([^\}]+)\}/g);
      while ((entry = iterator.next()) && !entry.done) {
        occurrences.push(entry.value[1]);
      }
      return occurrences;
    }

    withParameters(_parameters) {
      this._parameters = _parameters;
      return this;
    }

    build() {
      var lines, tree;
      this.payload = WeaverQueryBuilder.substituteParameters(this.payload, this._parameters);
      lines = this.payload.split('\n');
      tree = this._buildTree(lines);
      return this._buildQuery(tree);
    }

    _buildQuery(tree) {
      var i, len, method, query, ref, sub;
      query = new Weaver.Query();
      ref = tree.methods;
      for (i = 0, len = ref.length; i < len; i++) {
        method = ref[i];
        if (method.sub != null) {
          sub = this._buildQuery(method.sub);
          supportedMethods[method.name](query, ...method.args, sub);
        } else {
          supportedMethods[method.name](query, ...method.args);
        }
      }
      return query;
    }

    _buildTree(lines) {
      var i, last, len, line, method, pointer, previous, ref, stack, tree;
      tree = {
        methods: []
      };
      pointer = tree;
      stack = [];
      previous = void 0;
      for (i = 0, len = lines.length; i < len; i++) {
        line = lines[i];
        method = this._parseLine(line);
        if (method == null) {
          continue;
        }
        if (stack.length === 0) {
          stack.push({
            indent: method.indent,
            pointer
          });
        }
        if ((previous == null) || previous.indent === method.indent) {
          pointer.methods.push(method);
        } else if (method.indent > previous.indent) {
          pointer = {
            methods: []
          };
          stack.push({
            indent: method.indent,
            pointer
          });
          previous.sub = pointer;
          pointer.methods.push(method);
        } else {
          while (method.indent < stack[stack.length - 1].indent) {
            ref = stack, [...stack] = ref, [last] = splice.call(stack, -1);
          }
          ({pointer} = stack[stack.length - 1]);
          pointer.methods.push(method);
        }
        previous = method;
      }
      return tree;
    }

    _parseLine(line) {
      var chr, currentToken, doubleQuoted, escape, firstToken, i, indent, keywords, len, parseDateArguments, parseNodesWithGraph, push, singleQuoted, tokens, tree, trimmed;
      if (line.trim().startsWith('#')) {
        return void 0;
      }
      keywords = {};
      keywords.now = function() {
        return moment().utc();
      };
      keywords['@'] = function() {
        return '@';
      };
      line = line.replace('\t', ' ');
      trimmed = line.trim();
      firstToken = true;
      tokens = [];
      singleQuoted = false;
      doubleQuoted = false;
      escape = false;
      currentToken = '';
      indent = line.indexOf(trimmed);
      push = (tokens, currentToken, parse = false) => {
        if ((currentToken == null) || currentToken.length === 0) {
          return;
        }
        if (keywords[currentToken] != null) {
          currentToken = keywords[currentToken]();
        } else if (parse) {
          currentToken = JSON.parse(currentToken);
        } else {
          currentToken = this._valueCallback(currentToken);
        }
        return tokens.push(currentToken);
      };
      parseDateArguments = function(originalArguments) {
        var argument, found, i, index, len, regexp, tmpArgs;
        tmpArgs = [];
        for (index = i = 0, len = originalArguments.length; i < len; index = ++i) {
          argument = originalArguments[index];
          regexp = /^[ ]*(?<operation>\+|-)[ ]*(?<value>\d*\.?\d*)[ ]*(?<timeWindow>ms|milliseconds?|seconds?|minutes?|hours?|days?|weeks?|months?|quarters?|years?|[yQMwdhms])[ ]*$/;
          if (regexp.test(argument)) {
            found = argument.match(regexp);
            tmpArgs.push(originalArguments[0]);
            tmpArgs.push(moment(originalArguments[index - 1]).add(parseFloat(`${found.groups.operation}${found.groups.value}`), `${found.groups.timeWindow}`));
          }
        }
        if (tmpArgs.length > 0) {
          return tmpArgs;
        } else {
          return originalArguments;
        }
      };
      parseNodesWithGraph = function(originalArguments) {
        var firstAtIndex, graph, node, nodeId;
        firstAtIndex = originalArguments.indexOf('@');
        if (firstAtIndex > -1) {
          nodeId = originalArguments[firstAtIndex - 1];
          graph = originalArguments[firstAtIndex + 1];
          node = Weaver.Node.getFromGraph(nodeId, graph);
          originalArguments.splice(firstAtIndex - 1, 3, node);
          parseNodesWithGraph(originalArguments);
        }
        return originalArguments;
      };
      for (i = 0, len = trimmed.length; i < len; i++) {
        chr = trimmed[i];
        if (escape) {
          currentToken += chr;
          escape = false;
        } else if (chr === '\\') {
          escape = true;
        } else if (chr === '@') {
          push(tokens, '@');
        } else if (chr === '\'') {
          singleQuoted = !singleQuoted;
          if (!singleQuoted) {
            push(tokens, currentToken);
          }
          currentToken = '';
        } else if (chr === '"') {
          doubleQuoted = !doubleQuoted;
          if (!doubleQuoted) {
            push(tokens, currentToken);
          }
          currentToken = '';
        } else if (!singleQuoted && !doubleQuoted && chr === '#') {
          break;
        } else if (!singleQuoted && !doubleQuoted && chr === ' ') {
          push(tokens, currentToken, !firstToken);
          currentToken = '';
        } else {
          currentToken += chr;
        }
        firstToken = tokens.length === 0;
      }
      push(tokens, currentToken, !firstToken);
      if (tokens[0] == null) {
        return void 0;
      } else if (supportedMethods[tokens[0]] != null) {
        tree = {
          indent,
          name: tokens[0],
          args: tokens.slice(1)
        };
        tree.args = parseDateArguments(tree.args);
        tree.args = parseNodesWithGraph(tree.args);
        return tree;
      } else {
        throw new Error(`Method ${tokens[0]} not supported`);
      }
    }

  };

  // Export
  module.exports = WeaverQueryBuilder;

}).call(this);
